import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import './NavMenu.css';

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Close menu when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClick = (e) => {
      if (isOpen && !e.target.closest('.nav-container')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [isOpen]);

  return (
    <nav className="nav-container">
      <button 
        className="mobile-menu-button" 
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      <ul className={`nav-list ${isOpen ? 'open' : ''}`}>
        <NavItem to="/" label="HOME" active={location.pathname === '/'} />
        <NavItem to="/info" label="INFO" active={location.pathname === '/info'} />
        <NavItem to="/music" label="MUSIC" active={location.pathname === '/music'} />
        <NavItem to="/images" label="IMAGES" active={location.pathname === '/images'} />
        <NavItem to="/contact" label="CONTACT" active={location.pathname === '/contact'} />
      </ul>
    </nav>
  );
};

const NavItem = ({ to, label, active }) => {
  return (
    <li>
      <Link to={to}>
        <span className="nav-item">
          <span className={`nav-label ${active ? 'active' : ''}`}>
            {label}
          </span>
          <span className={`nav-background ${active ? 'active' : ''}`} />
        </span>
      </Link>
    </li>
  );
};

export default Nav;